import { useCallback, useState } from 'react';

interface GeolocationState {
  altitude: number;
  latitude: number;
  longitude: number;
  accuracy: number;
  error: string | null;
  loading: boolean;
}

const initialLocationState: GeolocationState = {
  altitude: 0,
  latitude: 0,
  longitude: 0,
  accuracy: 0,
  error: null,
  loading: true,
};

export const useGeolocation = () => {
  const [locationState, setLocationState] =
    useState<GeolocationState>(initialLocationState);

  const isValidLocation = () => {
    return (
      !locationState.loading &&
      !locationState.error &&
      locationState.latitude !== 0 &&
      locationState.longitude !== 0
    );
  };

  const requestUserLocation = useCallback(async () => {
    if (!navigator.geolocation) {
      setLocationState((prev) => ({
        ...prev,
        error: 'Geolocalização não é suportada pelo seu navegador',
        loading: false,
      }));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        setLocationState({
          altitude: position.coords.altitude || 0,
          latitude: position.coords.latitude || 0,
          longitude: position.coords.longitude || 0,
          accuracy: position.coords.accuracy || 0,
          error: null,
          loading: false,
        });
      },
      (error) => {
        setLocationState((prev) => ({
          ...prev,
          error: error.message,
          loading: false,
        }));
      },
      {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      },
    );
  }, []);

  return {
    ...locationState,
    isValidLocation,
    requestUserLocation,
  };
};
